export const hasReach = (el) => {
    let flag = false;
    if (el && el.getBoundingClientRect) {
        const { top: elTop } = el.getBoundingClientRect();
        flag = elTop < window.innerHeight;
    }
    return flag;
};
